import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const EnsurePageType = ({ requiredPageType }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const currentPageType = params.get('page_type');

    if (currentPageType !== requiredPageType) {
      params.set('page_type', requiredPageType);
      navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    }
  }, [location, navigate, requiredPageType]);

  return null;
};

export default EnsurePageType;